/* icon/UI 24px/Health Funds Small (HSA, HRA, FSA, spending account).svg: width 24px x height 24px */
export default class DlsIconHealthFundsSmall extends HTMLElement {
  static define(tagName = 'dls-icon-health-funds-small') {
    try {
      window.customElements.define(tagName, this);
    } catch (e) {
      /* console.error(e); */
    }
  }
  connectedCallback() {
    this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" display="block" pointer-events="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M9.622 15.868v.075c.108 1.194 1.15 1.98 2.353 1.98 1.202 0 2.344-.77 2.344-1.971 0-2.71-4.663-1.219-4.663-3.952 0-1.194 1.172-1.98 2.344-1.98s2.207.734 2.319 1.92V12M12 10.02V8.2m0 11.415v-1.692"/><path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5" d="M20.25 4V1.75H3.73a2.005 2.005 0 00-1.972 2.03C1.723 4.979 2.491 5.98 3.73 6h18.52v16.25H4.602c-1.575 0-2.852-1.175-2.852-2.75V3.78"/></svg>`;
  }
}
DlsIconHealthFundsSmall.define();
